
























































import Vue from 'vue';
import Status from '@/components/Status.vue';
import store from '@/store';
import { WebRequestStatus } from '../models';

export default Vue.extend({
  components: {
    Status
  },

  props: {
    organizationId: Number
  },

  data: () => {
    return {
      communityUrl: process.env.VUE_APP_UNRULR_ON_THE_WEB_URL
    };
  },

  computed: {
    status(): WebRequestStatus {
      return store.state.org.status;
    },

    errorMessages(): string[] {
      return store.state.org.errorMessages;
    }
  },

  created() {
    const userInfo = store.state.auth.user;

    if (!userInfo) {
      throw new Error('Trying to set up an org with a null user???');
    }

    store.dispatch.org.initIfDifferentOrg({
      userInfo,
      orgId: this.organizationId
    });
  },

  methods: {
    dismiss(index: number) {
      store.dispatch.org.dismissErrorMessage(index);
    }
  }
});
